import { ServiceType } from '@wix/ambassador-bookings-services-v2-service/types';
export const isCourseService = service => {
  return service.type === ServiceType.COURSE;
};
export const isAppointmentService = service => {
  return service.type === ServiceType.APPOINTMENT;
};
//# sourceMappingURL=service.js.map